import { ComponentProps, ReactNode } from 'react';

import { useSidebar } from '@/hooks/useSidebar';
import { SidebarOptions } from '@/shared/types/sidebar';

import { ResponsiveSidebarPanel } from './ResponsiveSidebarPanel';

interface SidebarProps {
  /** Accessible title forwarded to ResponsiveSidebarPanel. */
  title: string;
  /**
   * If set, the sidebar only mounts when the current openSidebar value is one
   * of these. Otherwise it mounts whenever any sidebar is open.
   */
  when?: SidebarOptions | SidebarOptions[];
  /** Forwarded to ResponsiveSidebarPanel. */
  order?: number;
  /** Forwarded to ResponsiveSidebarPanel. */
  size?: ComponentProps<typeof ResponsiveSidebarPanel>['size'];
  /** Forwarded to ResponsiveSidebarPanel. */
  dismissible?: boolean;
  children: ReactNode;
}

export const Sidebar = ({ title, when, order, size, dismissible, children }: SidebarProps) => {
  const { isOpen, close } = useSidebar();

  if (!isOpen(when)) {
    return null;
  }

  return (
    <ResponsiveSidebarPanel
      title={title}
      order={order}
      size={size}
      dismissible={dismissible}
      onClose={close}
    >
      {children}
    </ResponsiveSidebarPanel>
  );
};
